export default "__VITE_ASSET__DHRx701u__"